import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-368242f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " This group includes everybody who works at the Settle Location. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
      class: "demo-tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "Overview",
          name: "overview"
        }),
        _createVNode(_component_el_tab_pane, {
          label: "Members",
          name: "members"
        }),
        _createVNode(_component_el_tab_pane, {
          label: "Posts",
          name: "posts"
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}